(function (app) {

    app.provider("marketingTrackerApi",
        [
            function () {
                this.$get = [
                    "crmApiGateway", function (crmApiGateway) {
                        var service = {};

                        service.getToken = function (userId) {
                            return crmApiGateway.get("/Users/" + userId + "/MarketingTracker/Token");
                        },
                        service.getContactEventsByEmailAsync = function (email) {
                            return crmApiGateway.get("/Clients/MarketingTracker/Events/" + email);
                        };
                        return service;
                    }
                ];
            }
        ]);
})(window.app);